<edit-component rota="acesso-pessoal" [resource]="acessoPessoalResource" [service]="acessoPessoalService"></edit-component>
